import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { useIsEmailHubNewsletterPhaseAEnabled } from "@circle-react/hooks/useIsEmailHubNewsletterPhaseAEnabled";
import { newsletterQueries } from "@circle-react/lib/queries/newsletters";
import { useQuery } from "react-query";

interface NewsletterActivation {
  isActivated: boolean;
  isActivationRequired: boolean;
  isAvailable: boolean;
}

export const useNewsletterActivation = (): NewsletterActivation => {
  const { currentCommunityMember } = usePunditUserContext();
  const isFlagEnabled = useIsEmailHubNewsletterPhaseAEnabled();
  const isAvailable = isFlagEnabled && isCommunityAdmin(currentCommunityMember);
  const { data: newsletters, isSuccess } = useQuery({
    ...newsletterQueries.list(),
    enabled: isAvailable,
  });

  return {
    isAvailable,
    isActivated: isAvailable && isSuccess && newsletters.length > 0,
    isActivationRequired: isAvailable && isSuccess && newsletters.length === 0,
  };
};
